var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-autobuyer-box__small-text"},[_vm._v(" Current interval: "+_vm._s(_vm.intervalText)+" "),(_vm.isShowingBulk)?_c('span',[_c('br'),_vm._v(" "+_vm._s(_vm.bulkText)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }